/** 
 * Returns the result the Vigenère encryption on the given text with the given key.
 */
function crypt(input: string, key: number[]) {
    let output = "";
    let j = 0;
    for (const ch of input) {
        const cc = ch.codePointAt(0);
        if (isUppercase(cc)) {
            output += String.fromCodePoint((cc - 65 + key[j % key.length]) % 26 + 65);
            j++;
        } else if (isLowercase(cc)) {
            output += String.fromCodePoint((cc - 97 + key[j % key.length]) % 26 + 97);
            j++;
        } else {
            output += ch;
        }
    }
    return output;
}


/* 
 * Returns an array of numbers, each in the range [0, 26), representing the given key.
 * The key is case-insensitive, and non-letters are ignored.
 * Examples:
 * - filterKey("AAA") = [0, 0, 0].
 * - filterKey("abc") = [0, 1, 2].
 * - filterKey("the $123# EHT") = [19, 7, 4, 4, 7, 19].
 */
function filterKey(key: string): number[] {
    let result = [];
    for (const ch of key) {
        const cc = ch.codePointAt(0);
        if (isLetter(cc))
            result.push((cc - 65) % 32);
    }
    return result;
}


// Tests whether the given character code is a Latin letter.
function isLetter(c: number): boolean {
    return isUppercase(c) || isLowercase(c);
}

// Tests whether the given character code is an Latin uppercase letter.
function isUppercase(c: number): boolean {
    return 65 <= c && c <= 90;  // 65 is character code for 'A'. 90 is 'Z'.
}

// Tests whether the given character code is a Latin lowercase letter.
function isLowercase(c: number): boolean {
    return 97 <= c && c <= 122;  // 97 is character code for 'a'. 122 is 'z'.
}

function encdec(text: string, key:string, decode: boolean): string {
    if (key.length == 0) {
        return;
    }
    
    let keyArray = filterKey(key);
    if (keyArray.length == 0) {
        return;
    }
    
    if (decode) {
        for (let i = 0; i < keyArray.length; i++)
            keyArray[i] = (26 - keyArray[i]) % 26;
    }
    
    return  crypt(text, keyArray);
}


export function vig_encode(text: string,key: string): string {
    return encdec(text,key,false);
}

export function vig_decode(text: string, key: string): string {
    return encdec(text,key,true);
}
